module.exports = __webpack_public_path__ + "img/img (50).afc93f51.jpg";